
import { useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { fretesService } from '../services/api'
import { useAuth } from '../contexts/AuthContext'
import './FretesDisponiveis.css'

function FretesDisponiveis() {
    const [fretes, setFretes] = useState([])
    const [loading, setLoading] = useState(true)
    const [erro, setErro] = useState(null)
    const { usuario, isLogado } = useAuth()
    const navigate = useNavigate()

    useEffect(() => {
        // Redirecionar se não for motorista VERIFICADO (PAGO)
        const isVerificado = (usuario?.motorista_verificado === true || usuario?.motoristaVerificado === true) && 
                             usuario?.expiracao_motorista && 
                             new Date(usuario?.expiracao_motorista) > new Date();

        if (isLogado && !isVerificado) {
            navigate('/area-motorista')
            return
        }

        carregarFretes()
    }, [isLogado, usuario, navigate])

    const carregarFretes = async () => {
        setLoading(true)
        try {
            const response = await fretesService.proximos()
            setFretes(response.anuncios)
        } catch (error) {
            console.error('Erro ao buscar fretes:', error)
            setErro('Não foi possível carregar os fretes disponíveis.')
        } finally {
            setLoading(false)
        }
    }

    const formatPrice = (value) => {
        return new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL',
            minimumFractionDigits: 0
        }).format(value)
    }

    if (loading) return <div className="loading">Carregando fretes...</div>

    return (
        <div className="fretes-page">
            <div className="page-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '15px', marginBottom: '20px' }}>
                <div>
                    <h1 style={{ margin: 0 }}>Fretes Disponíveis</h1>
                    <p style={{ margin: '5px 0 0 0' }}>Oportunidades recentes na sua região ({usuario?.cidade}/{usuario?.estado})</p>
                </div>
                <button
                    onClick={() => {
                        if (usuario?.tipo_veiculo || usuario?.tipoVeiculo) {
                            alert('Veículo já foi cadastrado!');
                        } else {
                            navigate('/adicionar-tipo?tipo=motorista&modo=editar');
                        }
                    }}
                    className="btn"
                    style={{
                        backgroundColor: (usuario?.tipo_veiculo || usuario?.tipoVeiculo) ? 'rgba(255,255,255,0.05)' : '#f59e0b',
                        color: (usuario?.tipo_veiculo || usuario?.tipoVeiculo) ? '#94a3b8' : '#0f172a',
                        border: (usuario?.tipo_veiculo || usuario?.tipoVeiculo) ? '1px solid rgba(255,255,255,0.1)' : 'none',
                        fontWeight: 'bold',
                        padding: '10px 20px',
                        borderRadius: '8px',
                        cursor: 'pointer',
                        transition: 'all 0.2s'
                    }}
                >
                    {(usuario?.tipo_veiculo || usuario?.tipoVeiculo) ? '✅ Veículo Cadastrado' : '🚚 Cadastrar Veículo'}
                </button>
            </div>

            {(!usuario?.tipo_veiculo && !usuario?.tipoVeiculo) && (
                <div className="alert-cadastro-veiculo" style={{
                    backgroundColor: 'rgba(245, 158, 11, 0.1)',
                    border: '1px solid rgba(245, 158, 11, 0.25)',
                    borderRadius: '12px',
                    padding: '1.25rem',
                    marginBottom: '1.5rem',
                    color: '#fbbf24',
                    fontSize: '0.95rem',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px'
                }}>
                    <span style={{ fontSize: '1.25rem' }}>⚠️</span>
                    <div>
                        <strong>Perfil Incompleto:</strong> Seu perfil de motorista está oculto para outros usuários na listagem pública pois você ainda não cadastrou seu veículo. Clique no botão acima para cadastrar!
                    </div>
                </div>
            )}

            {erro && <div className="erro-msg">{erro}</div>}

            <div className="fretes-grid">
                {fretes.length > 0 ? (
                    fretes.map(frete => (
                        <div key={frete.id} className="frete-card">
                            <div className="frete-header">
                                <span className={`selo-frete ${frete.tipo_veiculo?.toLowerCase() || 'padrao'}`}>
                                    {frete.categoria}
                                </span>
                                <span className="data-frete">
                                    {new Date(frete.criado_em).toLocaleDateString()}
                                </span>
                            </div>

                            <div className="frete-body">
                                <h3>{frete.titulo}</h3>

                                <div className="frete-info">
                                    <div className="info-item">
                                        <span className="icon">📍</span>
                                        <div>
                                            <strong>Origem:</strong><br />
                                            {frete.cidade}, {frete.estado}
                                        </div>
                                    </div>
                                    <div className="info-item">
                                        <span className="icon">⚖️</span>
                                        <div>
                                            <strong>Carga:</strong><br />
                                            {frete.quantidade} cabeças
                                        </div>
                                    </div>
                                </div>

                                <div className="frete-preco">
                                    Valor da Carga: <strong>{formatPrice(frete.preco)}</strong>
                                </div>
                            </div>

                            <div className="frete-actions">
                                <Link to={`/anuncio/${frete.id}`} className="btn btn-primary btn-block">
                                    Ver Detalhes e Candidatar
                                </Link>
                            </div>
                        </div>
                    ))
                ) : (
                    <div className="sem-fretes">
                        <div className="icon">🚚</div>
                        <h2>Nenhum frete encontrado</h2>
                        <p>Não há anúncios recentes na sua região no momento.</p>
                        <button className="btn btn-secondary" onClick={carregarFretes}>
                            Atualizar Lista
                        </button>
                    </div>
                )}
            </div>
        </div>
    )
}

export default FretesDisponiveis
